import React from 'react';
import { parseEvidenceBullets } from '../../lib/helpers';

export function BulletList({ items, depth = 0 }) {
  return (
    <ul style={{ listStyle: "none", padding: 0, margin: depth > 0 ? "4px 0 4px 16px" : "0" }}>
      {items.map((item, i) => (
        <li key={i} style={{
          display: "flex", alignItems: "flex-start", gap: 8,
          marginBottom: depth === 0 ? 6 : 3,
          fontSize: depth === 0 ? 12 : 11,
          color: depth === 0 ? "var(--text)" : "var(--muted)",
          lineHeight: 1.55,
        }}>
          <span style={{
            flexShrink: 0,
            color: depth === 0 ? "var(--accent)" : "var(--accent2)",
            fontSize: depth === 0 ? 14 : 10,
            lineHeight: depth === 0 ? "1.3" : "1.7",
            userSelect: "none",
          }}>•</span>
          <div style={{ flex: 1 }}>
            <span>{item.text}</span>
            {item.children.length > 0 && <BulletList items={item.children} depth={depth + 1} />}
          </div>
        </li>
      ))}
    </ul>
  );
}

/** Convenience wrapper: pass raw text, get rendered bullets */
export function EvidenceRequirements({ text }) {
  if (!text) return null;
  const items = parseEvidenceBullets(text);
  if (!items.length) return <div style={{ fontSize: 12, color: "var(--muted)" }}>{text}</div>;
  return <BulletList items={items} />;
}
